import { render, staticRenderFns } from "./fccPublicacoesContasBancarias.vue?vue&type=template&id=3b091036"
import script from "./fccPublicacoesContasBancarias.vue?vue&type=script&lang=js"
export * from "./fccPublicacoesContasBancarias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports